import { useTranslation } from 'react-i18next';

import { Header } from 'features/my-profile/components/Header';
import { ReturnFromProfileButton } from 'features/my-profile/components/ReturnFromProfileButton';

import { PasswordChangeForm } from './components/PasswordChangeForm';

export const PasswordPage = () => {
  const { t } = useTranslation('myProfile');

  return (
    <div data-testid={'my-profile-password'}>
      <ReturnFromProfileButton />
      <Header data-testid={'password-page-header'}>{t('password.header')}</Header>
      <PasswordChangeForm />
    </div>
  );
};
